/**
* TextArea.js
* 
* Created on 10-okt-2014, 16:35:03
*
* @author Harm Boschloo for Ranj
* @author Reinier Feijen for Ranj
**/

import DprDOMElement from "../dom/DprDOMElement";
import AbstractTextInput from "./AbstractTextInput";
import TextUtil from "./TextUtil";

export default class TextArea extends AbstractTextInput {
    constructor(target, width, height, htmlContainerId, maxCharacters = 0) {
        super(target, width, height, htmlContainerId, maxCharacters);

        // Enables createjs wrapping.
        this._target.lineWidth = width;

        this._init(this._createMultiLineTextInput(width, height));
    }

    _createMultiLineTextInput(width, height) {
        const fontSize = TextUtil.getFontSize(this._target) * this._target.scaleX;
        const x = this._target.x - 2;
        const y = this._target.y - 1;

        const inputDOM = document.createElement(`textarea`);
        inputDOM.setAttribute(`id`, this._id);
        inputDOM.setAttribute(`style`, `
            position: absolute;
            z-index: 99;
            top: 0px;
            left: 0px;
            background: transparent;
            border: 0;
            overflow: hidden;
            resize: none;
            outline: none;
        `);

        const container = document.getElementById(this._htmlContainerId);
        container.append(inputDOM);

        const htmlElement = inputDOM;
        htmlElement.innerHTML = this._target.text;
        htmlElement.style.font = this._target.font;
        htmlElement.style.fontSize = fontSize + "px";
        htmlElement.style.color = this._target.color;
        htmlElement.style.width = width + "px";
        htmlElement.style.height = height + "px";
        htmlElement.style.lineHeight = this._target.lineHeight + "px";
        htmlElement.style.visibility = "hidden";

        const domElement = new DprDOMElement(htmlElement);
        domElement.x = x;
        domElement.y = y;
        if (this._target.textAlign === "center") {
            domElement.x -= width / 2;
            htmlElement.style.textAlign = "center";
        }

        return domElement;
    }
}